import { render } from "./NoteHistory.vue?vue&type=template&id=602c6ddc&scoped=true"
import script from "./NoteHistory.vue?vue&type=script&lang=js"
export * from "./NoteHistory.vue?vue&type=script&lang=js"

import "./NoteHistory.vue?vue&type=style&index=0&id=602c6ddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602c6ddc"]])

export default __exports__